import { createAction, props } from '@ngrx/store';
import {
  CustomerOfferListItemResponse,
  FiltersResponse,
  PaginatedApiResponseWithFilters,
  WorkCouncilOfferListItemResponse,
  CustomerOfferResponse,
} from '../../../api';

// Offers List
export const loadOffersList = createAction('[Offers] Load Customer Offers List', props<{ payload: any }>());
export const setOffersList = createAction(
  '[Offers] Set Customer Offers List',
  props<{
    payload: PaginatedApiResponseWithFilters & {
      data?: Array<CustomerOfferListItemResponse | WorkCouncilOfferListItemResponse>;
      filters?: FiltersResponse;
    };
  }>()
);
export const successOffersList = createAction('[Offers] Success Customer Offers List');
export const errorOffersList = createAction('[Offers] Error Customer Offers List');

// Offer Details
export const loadOfferDetails = createAction(
  '[Offers] Load Customer Offer Details',
  props<{ payload: { offer: number } }>()
);
export const setOfferDetails = createAction(
  '[Offers] Set Customer Offer Details',
  props<{ payload: CustomerOfferResponse }>()
);
export const successOfferDetails = createAction('[Offers] Success Customer Offer Details');
export const errorOfferDetails = createAction('[Offers] Error Customer Offer Details');

export const downloadOfferedDaysFile = createAction(
  '[Offers] Download offered days file',
  props<{ payload: { offer: number; openInModal?: boolean } }>()
);
export const setDownloadOfferedDaysFile = createAction(
  '[Offers] Set download offered days file',
  props<{ payload: { document: Blob } }>()
);
export const clearDownloadOfferedDaysFile = createAction('[Offers] Clear download offered days file');
export const successDownloadOfferedDaysFile = createAction('[Offers] Success download offered days file');
export const errorDownloadOfferedDaysFile = createAction('[Offers] Error download offered days file');
